// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://dev.azure.com/office/ISS/_git/augloop-server?path=%2Fmodules%2Ftypes-core%2Fsrc%2Fscenarios.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------
import { Scenario } from '../../scenarios';
export class ScenarioValidator {
    validate(value) {
        if (!ScenarioValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "Scenario"' };
        }
        return { success: true };
    }
}
ScenarioValidator.validValues = new Set([Scenario.Unknown, Scenario.Testing, Scenario.CopilotSummary, Scenario.CopilotCompose, Scenario.Rewrite, Scenario.ChatQnA, Scenario.CIQ, Scenario.Editor, Scenario.Handoff, Scenario.ReadAloud]);
export const scenarioValidatorInstance = new ScenarioValidator();
//# sourceMappingURL=scenarios-validator.g.js.map